/**
 * Annotation ink palette.
 *
 * Single source of truth for every "color the user picks" surface:
 *   - the side-toolbar's drawing-tool swatch row
 *   - the stamp popover's preset chips
 *   - the selection toolbar's highlight-color picker
 *
 * Pre-Phase-4 each surface inlined its own array. Two consequences
 * the shared palette fixes:
 *
 *   1. Yellow/blue drift — the side toolbar used `#E0A23A` /
 *      `#3A6FE0` while the selection toolbar used `#FFD400` /
 *      `#4F8DFF`, so picking "yellow" in one place gave you a
 *      different yellow than picking "yellow" in the other.
 *   2. Adding a new color (e.g. orange) meant editing three files
 *      and remembering all three.
 *
 * After: each surface projects from `INK` and the visible color set
 * matches across the modal.
 */
/**
 * Canonical ink colors. Each pair (`id`, `hex`) is the source of
 * truth — projections below pick subsets and re-shape per surface.
 *
 * Values are saturated enough to read as "ink" against light card
 * backgrounds without being neon. Hue family is consistent across
 * every consumer so a "yellow" stamp visually matches a "yellow"
 * highlight matches a "yellow" drawing stroke.
 */
export const INK = {
    green: { id: "green", label: "Green", hex: "#3AA66E" },
    yellow: { id: "yellow", label: "Yellow", hex: "#E0A23A" },
    pink: { id: "pink", label: "Pink", hex: "#D9457E" },
    blue: { id: "blue", label: "Blue", hex: "#3A6FE0" },
    red: { id: "red", label: "Red", hex: "#E03A3A" },
    purple: { id: "purple", label: "Purple", hex: "#7E3AE0" },
};
